import { SeriesPointXY } from '../Types';

const getXStepFromSeries = (getX: (x: null | number) => null | number, series: SeriesPointXY[]) => {
  if (series.length < 2) {
    return null;
  }

  const x1 = getX(series[0].x);
  const x2 = getX(series[1].x);

  return x1 === null || x2 === null ? null : x2 - x1;
};

export default getXStepFromSeries;
